import type { AnimationI } from "tweenly"
import { PayloadAction } from "@reduxjs/toolkit"
import { compareAnimations } from "../../../../helpers/animation.helpers"
import { ObjectsStateT } from "../../objects.slice"
import { UpdateOffsetAnimationsT } from "./animationTypes"
import { startOffsetAnimationBaseAction } from "./startOffsetAnimationBaseAction"

export const startOffsetAnimationsBaseAction = (
    state: ObjectsStateT,
    action: PayloadAction<UpdateOffsetAnimationsT>
) => {
    const offset = action.payload.offset

    const sortedAnimations: AnimationI[] = [...action.payload.selectedAnimations].sort(
        compareAnimations
    )

    sortedAnimations.forEach((animation: AnimationI) => {
        startOffsetAnimationBaseAction(state, {
            payload: { animation, offset, objectId: animation.objectId },
            type: action.type,
        })
    })
}
